export const EDIT_INQUIRY_CALLER_COMPONENT_NAME = 'editInquiryCallerComponentName';

export type APPLICATION_CONFIG_OBJECT = {
  [EDIT_INQUIRY_CALLER_COMPONENT_NAME]?: string;
};
